export default {
  most_popular: 'Most Popular',
  tiered_input: {
    label: 'How many users are on your team?',
    description: '* Discounts start at 15 users',
  },
  currency: 'Currency',
  currencies: {
    mxn: 'MXN',
    usd: 'USD',
  },
  recurrances: {
    day: 'Daily',
    days: 'Days',
    week: 'Weekly',
    weeks: 'Weeks',
    month: 'Monthly',
    months: 'Months',
    year: 'Yearly',
    years: 'Years',
  },
  free_trial: 'Start your {numberOfDays}-day free trial',
  units: 'users',
  unit: 'per user',
  yearly_tooltip_help: '(decimal places may vary)',
  free_tooltip: 'Always free',
  time: {
    day: 'per Day',
    days: 'per Days',
    week: 'per Week',
    weeks: 'per Weeks',
    month: 'per Month',
    months: 'per Months',
    year: 'per Year',
    years: 'per Years',
  },
  actions: {
    buy_now: 'Buy Now',
    contact_sales: 'Contact Sales',
  },
  discount_badge_for_yearly: 'Save 16%',
  footer: '* Prices shown excludes taxes <br /> * Ask for our discounts for small businesses',
};
